module.exports = __webpack_public_path__ + "static/media/Preview.97acdee5.svg";